import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMultiple", "isReadonly", "allowClear", "placeholder", "emptyMessage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { TagFilled } from '@ant-design/icons';
import { Select, Space } from 'antd';
import { getLabelStore } from 'core/modules/labels/label.store';
import styled from 'styled-components';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Renders a select to select labels. */
export var LabelSelect = function LabelSelect(_ref) {
  var isMultiple = _ref.isMultiple,
      isReadonly = _ref.isReadonly,
      allowClear = _ref.allowClear,
      placeholder = _ref.placeholder,
      emptyMessage = _ref.emptyMessage,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getLabelStore = getLabelStore(),
      labels = _getLabelStore.labels;

  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    bordered: !isReadonly,
    disabled: isReadonly,
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    placeholder: isReadonly ? emptyMessage : placeholder,
    children: labels.map(function (label) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: label.id,
        title: label.name,
        children: /*#__PURE__*/_jsxs(OptionContent, {
          size: "small",
          children: [/*#__PURE__*/_jsx("span", {
            className: "icon",
            children: /*#__PURE__*/_jsx(TagFilled, {
              style: {
                color: label.color
              }
            })
          }), /*#__PURE__*/_jsx("span", {
            className: "label",
            children: label.name
          })]
        })
      }, label.id);
    })
  }));
}; // Styles

var OptionContent = styled(Space).withConfig({
  displayName: "LabelsSelect__OptionContent",
  componentId: "sc-npmbax-0"
})([""]);